import React from 'react';
import { Keys, locale } from 'src/i18n';
// eslint-disable-next-line vymo-ui/restrict-import
import { CASE, LOAN } from '../constant';
import AuditHistory from './audit';
import Cases from './cases';
import EntityDetails from './details';
import RelatedRecords from './relatedRecords';
import Trails from './trails';

export const getDetailTabs = (props, details) => {
  if (props.revyre) {
    const { workflowType } = props;
    const tabs: any = [];

    tabs.push({
      key: 'details',
      label: locale(Keys.DETAILS),
      children: <EntityDetails {...props} />,
    });

    if (workflowType === CASE) {
      tabs.push({
        key: 'trails',
        label: locale(Keys.TRAILS),
        children: <Trails {...props} />,
      });
    }

    if (details?.referredEntityDetails?.length) {
      details.referredEntityDetails.forEach((entity) => {
        tabs.push({
          key: entity.workflowType,
          label: entity.flowName,
          children:
            workflowType === LOAN && entity.workflowType === CASE ? (
              <Cases {...props} module={{ ...entity }} />
            ) : (
              <RelatedRecords
                {...props}
                module={{
                  ...entity,
                  code: entity.workflowType,
                  name: entity.flowName,
                }}
              />
            ),
        });
      });
    }

    tabs.push({
      key: 'audit_history',
      label: locale(Keys.HISTORY),
      children: <AuditHistory {...props} />,
    });

    return tabs;
  }
  return [];
};
